import React, {useEffect, useState} from 'react';
import {Button, Col, Modal} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import errorHelper from "../../helpers/ErrorHelper";
import {Redirect} from "react-router-dom";
import businessApiService from "../../api/business-api-service";
import lsHelpers from "../../helpers/LsHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);

const ErrorModal = (props) => {
    const [visible, setVisible] = useState(props.showError === true);

    const onDismiss = () => setVisible(false);

    useEffect(() => {
        if (props.showError !== visible) {
            setVisible(props.showError === true)
        }
    });

    function toggle(formModal) {
        // setVisible(!visible);
        props.toggleErrorModal();
    }

    function report() {
        businessApiService.sendSupportMessage({title: "error", message: (props.error && props.error.data) ? props.error.data : "not clear"})
            .then(res => {
               toggle()
            })
            .catch((e) => {
                toggle();
                //alert("Something went wrong. Please try again.")
            });
        toggle()
    }

    function isNameTakenError(error) {
        if (error && error.data && error.data.message) {
            const m = error.data.message;
            return m.includes("has already been") || m.includes("уже существуе") || m.includes("ya está en")
        }
        else return false
    }

    function mustLogout() {
        if ((props.error && props.error.response && props.error.response.data) || (props.error && props.error.status)) {
            const m = props.error.response && props.error.response.data ? props.error.response.data.message : "";
            if (m) {
                return m === "Not enough or too many segments";
            }
            else if (props.error.status && [422, 498].includes(props.error.status)) {
                if (isNameTakenError(props.error)) return false
                else return true
            }
            else return false
        }
        else return false
    }

    if (mustLogout() === false) {

        function errorText() {
            if (props.error) return errorHelper.errorMessage(props.error);
            else return alertStrings.generic_error
        }

        const localize = () => {
            const loc = localeHelpers.currentLocale();
            alertStrings.setLanguage(loc);
            commonStrings.setLanguage(loc);
        };

        localize();
        return (
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={visible}
                toggle={() => toggle("notificationModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => toggle("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="py-3 text-center">
                        <i style={{color: "white", fontSize: 50}} className="fas fa-exclamation-circle"/>
                        <h3 className="mt-4 text-white">{alertStrings.generic_error_title}</h3>
                        <p>
                            {errorText()}
                        </p>
                    </div>
                </div>
                <div className="modal-footer">
                    <Col className="text-center">
                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={report}>
                            {alertStrings.report}
                        </Button>

                        <Button className="btn-white" color="default" type="button" style={{marginTop: 10}}
                                onClick={toggle}
                        >
                            {commonStrings.close}
                        </Button>

                    </Col>
                </div>
            </Modal>
        );
    }
    else {
        lsHelpers.logout()
        return (<Redirect from="*" to="/auth/login"/>)
    }
};

export default ErrorModal;